import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/services/auth.service";
import { PerfilService } from "../../services/perfil.service";
import { IonDatetime, ModalController, AlertController } from "@ionic/angular";
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
  selector: "app-perfil",
  templateUrl: "./perfil.component.html",
  styleUrls: ["./perfil.component.scss"],
})
export class PerfilComponent implements OnInit {
  private id: number;
  private auth_key: string;
  displayUserData: any;

  perfilShow: number;
  showPublic: boolean;
  showPriva: boolean;

  formGeneralData: FormGroup;

  constructor(
    private authService: AuthService,
    private perfilService: PerfilService,
    private alertCtrl: AlertController,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.createForm();
    this.authService.userData$.subscribe((res: any) => {
      this.displayUserData = res;
      this.auth_key = this.displayUserData?.auth_key;
      this.id = this.displayUserData?.id;
      this.perfilService
        .get(this.id, this.auth_key)
        .subscribe((resPerfil: any) => {
          if (resPerfil.auth_key) {
            this.formGeneralData.patchValue(resPerfil.data);
          }
        });
    });
  }

  createForm() {
    this.formGeneralData = this.fb.group({
      nombre: [""],
      nickname: [""],
      correo: [{ value: "", disabled: true }],
    });
  }

  ionViewWillEnter() {}

  setVista(id) {
    this.perfilShow = id;
    if (id == 0) {
      this.showPublic = true;
      this.showPriva = false;
    } else {
      this.showPublic = false;
      this.showPriva = true;
    }
    this.changeState(this.perfilShow);
  }

  changeState(estado) {
    this.perfilService
      .updateState(this.id, this.auth_key, estado)
      .subscribe((res: any) => {
        if (res.result) {
          this.perfilService
            .get(this.id, this.auth_key)
            .subscribe((resPerfil: any) => {
              if (resPerfil.auth_key) {
                this.formGeneralData = resPerfil.data;
                //this.perfilShow = this.formGeneralData.estado;
              }
            });
        } else {
          this.presentAlert(res.mensaje);
        }
      });
  }

  async presentAlert(msg) {
    const alert = await this.alertCtrl.create({
      header: "Alerta",
      message: msg,
      buttons: ["Aceptar"],
    });
    await alert.present();
    const { role } = await alert.onDidDismiss();
  }

  async updateProfile() {
    const alert = await this.alertCtrl.create({
      cssClass: "my-custom-class",
      header: "Confirmar!",
      message: "¿Desea actualizar la informacion personal?",
      buttons: [
        {
          text: "Cancelar",
          role: "cancel",
          cssClass: "secondary",
          handler: (res) => {
            alert.dismiss();
          },
        },
        {
          text: "Aceptar",
          handler: () => {
            this.perfilService
              .updatePerfil(this.id, this.auth_key, this.formGeneralData.value)
              .subscribe((res: any) => {
                if (!res.error) {
                  this.ngOnInit();
                  alert.dismiss();
                  this.actionSaveDescription(
                    "¡Hecho!",
                    "Se actualizo la información del usuario"
                  );
                } else {
                  this.actionSaveDescription(
                    "¡ocurrió un error!",
                    "Inténtelo más tarde"
                  );
                }
              });
          },
        },
      ],
    });
    await alert.present();
  }

  async actionSaveDescription(header, message) {
    const alert = await this.alertCtrl.create({
      cssClass: "my-custom-class",
      header: header,
      message: message,
      buttons: [
        {
          text: "Aceptar",
          role: "cancel",
          cssClass: "secondary",
        },
      ],
    });

    await alert.present();
  }
}
